import {Redirect} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Xwrapper} from 'react-xarrows';
import Spinner from '../../common/Spinner';
import Container from '../../common/layout/Container';
import Error from '../../common/Error';
import TaskViewHeader from './header/TaskViewHeader';
import TaskGrid from './task_grid/TaskGrid';
import ProcessAssigneePopup from '../../processes/process_assignee/ProcessAssigneePopup';
import {useTaskView} from './context/task_view.context';
import routes from '../routes';

const TaskView = () => {
  const {
    processId, isLoading, error,
    processActionsPopupData, setProcessActionsPopupData,
    isActionProcessing, setIsActionProcessing, getProcessDetails
  } = useTaskView();
  const {t} = useTranslation('tasks');

  if (!processId) {
    return <Redirect to={routes.tasks()} />;
  }

  if (isLoading) {
    return <Spinner loadingText={t('currentTask.loadingText')} />;
  }

  if (error) {
    return (
      <Container>
        <Error message={error} />
      </Container>
    );
  }

  return (
    <Xwrapper>
      <TaskViewHeader />
      <TaskGrid />
      <ProcessAssigneePopup
        processActionsPopupData={processActionsPopupData}
        setProcessActionsPopupData={setProcessActionsPopupData}
        isActionProcessing={isActionProcessing}
        setIsActionProcessing={setIsActionProcessing}
        getProcessData={getProcessDetails}
      />
    </Xwrapper>
  );
};

export default TaskView;
